export const ContentSnType = {
    // number on the left is ContentSnTypeId
    1: "Instagram Reel",
    2: "Instagram Post",
    3: "Instagram Story",
    4: "TikTok Video",
    5: "Cover Image",
    6: "Snapchat Video",
    7: "YouTube Video",
    8: "Standard Video",
    9: "Standard Picture",
};


// WEBPACK FOOTER //
// ./components/content_type/constants.js